import React, { forwardRef } from "react";
import { requireNativeComponent, Platform, ViewProps } from "react-native";
import { requireNativeViewManager } from "expo-modules-core";

interface LivestreamMjpegViewProps extends ViewProps {
  /** The MJPEG stream URL to load */
  source?: string;
  /** Called when the stream starts loading */
  onLoadStart?: () => void;
  /** Called when the first frame is rendered */
  onLoadEnd?: () => void;
  /** Called when an error occurs */
  onError?: (event: { nativeEvent: { error: string } }) => void;
}

// iOS uses RCTViewManager (old bridge), Android uses Expo Modules
const NativeLivestreamMjpegView =
  Platform.OS === "ios" ? requireNativeComponent<LivestreamMjpegViewProps>("MJPEGStreamView")
  : Platform.OS === "android" ? requireNativeViewManager<LivestreamMjpegViewProps>("MJPEGStreamView")
  : null;

export const LivestreamMjpegView = forwardRef<unknown, LivestreamMjpegViewProps>((props, _ref) => {
  if (Platform.OS === "web" || !NativeLivestreamMjpegView) {
    return null;
  }
  return <NativeLivestreamMjpegView {...props} />;
});

LivestreamMjpegView.displayName = "LivestreamMjpegView";

export default LivestreamMjpegView;
